import { render, staticRenderFns } from "./PFLoan.vue?vue&type=template&id=efb4cf24"
import script from "./PFLoan.vue?vue&type=script&lang=js"
export * from "./PFLoan.vue?vue&type=script&lang=js"
import style0 from "./PFLoan.vue?vue&type=style&index=0&id=efb4cf24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports